import { render } from "./avatarsSection.vue?vue&type=template&id=44ce5429&scoped=true"
import script from "./avatarsSection.vue?vue&type=script&lang=js"
export * from "./avatarsSection.vue?vue&type=script&lang=js"

import "./avatarsSection.vue?vue&type=style&index=0&id=44ce5429&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44ce5429"]])

export default __exports__